/**
 * Sub-tag filter predicate shared by web + mobile Discover.
 * OR semantics: an empty selection matches all; otherwise the item must
 * carry at least one of the selected sub-tags.
 */
export function matchesSubtags(
  item: { readonly tags?: readonly string[] | null },
  selected: readonly string[],
): boolean {
  if (selected.length === 0) return true;
  const tags = item.tags ?? [];
  return selected.some((s) => tags.includes(s));
}
